import ApiService from "@/services/Api"
import {
	GetLatestUpsellAttemptInput,
	GetLatestUpsellAttemptResponse,
	InitiateUpsellCheckoutInput,
	InitiateUpsellCheckoutResponse,
	PlanAddons,
	UpsellQuantityType
} from "@/protocols/planAddons"
import { InboxLimits } from "@/protocols/instance"

class AccountService {
	async retrievelAllPlanAddonsByUpsellType<Type extends keyof InboxLimits> (upsellType: UpsellQuantityType, limitsType: Type): Promise<PlanAddons<Type>> {
		const response = await ApiService.get("/account/plan-addons", {
			params: {
				upsellType,
				limitsType
			}
		})

		return response.data.planAddons
	}

	async initiateUpsellCheckout (
		data: InitiateUpsellCheckoutInput
	): Promise<InitiateUpsellCheckoutResponse> {
		const response = await ApiService.post("/account/upsell/checkout", {
			...data
		})

		return response.data
	}

	async getLatestUpsellAttempt (
		data: GetLatestUpsellAttemptInput
	): Promise<GetLatestUpsellAttemptResponse> {
		const response = await ApiService.get("/account/upsell/last-upsell-details", {
			params: {
				upsellType: data.upsellType
			}
		})

		return response.data
	}
}

export default new AccountService()
